export default "__VITE_ASSET__BnPFPxvr__"